export default __webpack_public_path__ + "static/media/Champagne_et_Limousines.97e52f7c.ttf";